import { Dialog, DialogProps } from "@mui/material";
import React, { ReactNode } from "react";
import { BNModalHeader } from "./BNModalHeader";

interface BNDialogProps {
  title?: ReactNode;
  children: any;
  open: boolean;
  onClose: () => void;
  preventCloseOnDismiss?: boolean;
  classes?: any;
  className?: DialogProps["className"];
  important?: boolean;
  showCloseButton?: boolean;
  slotProps?: DialogProps["slotProps"];
  maxWidth?: DialogProps["maxWidth"];
  fullWidth?: DialogProps["fullWidth"];
  scroll?: DialogProps["scroll"];
}

const BNDialog: React.FC<BNDialogProps> = (props) => {
  const {
    title,
    children,
    open,
    onClose,
    preventCloseOnDismiss,
    classes,
    className,
    important,
    showCloseButton = true,
    slotProps,
    maxWidth,
    fullWidth,
    scroll,
    ...restOfProps
  } = props;

  const handleClose = (event: unknown, reason: string) => {
    if (preventCloseOnDismiss === true && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      classes={classes}
      transitionDuration={70}
      sx={{
        zIndex: important ? 1600 : undefined,
        m: 1,
      }}
      onClose={handleClose}
      maxWidth={maxWidth}
      className={className}
      fullWidth={fullWidth}
      scroll={scroll}
      open={open}
      data-uit-container="dialog"
      {...restOfProps}
      slotProps={slotProps}
    >
      <BNModalHeader onClose={() => onClose()} title={title} showCloseButton={showCloseButton} />
      {children}
    </Dialog>
  );
};

export default BNDialog;
